import {
  RlMarketplaceHealthCheckResponse,
  RlMarketplaceWidgetResponse,
} from 'marketplace/types/lds';
import {
  AppField,
  InvokeServerMethodResponse,
  RlMarketplaceWidget,
} from 'marketplace/types/marketplace';
import { LDSHttpClient } from './lds-http-client';

class LocalDevServerApiClient extends LDSHttpClient {
  public async healthCheck(): Promise<RlMarketplaceHealthCheckResponse> {
    const response = await this.get<RlMarketplaceHealthCheckResponse>(
      '/rl-marketplace/health-check',
    );

    return response;
  }

  public async getWidgets(): Promise<RlMarketplaceWidgetResponse> {
    const response = await this.get<RlMarketplaceWidgetResponse>('/widgets');

    return response;
  }

  public async getWidgetById(widgetId: string): Promise<RlMarketplaceWidget> {
    const response = await this.get<RlMarketplaceWidget>(
      `/widgets/${widgetId}`,
    );

    return response;
  }

  public async getWidgetFields(
    widgetId: string,
    payload: Record<string, unknown>,
  ): Promise<AppField[]> {
    const response: AppField[] = await this.post(
      `/widgets/${widgetId}/fields`,
      payload,
    );

    return response;
  }

  public async invokeServerMethod(
    name: string,
    context: Record<string, unknown>,
    payload: Record<string, unknown>,
    params?: Record<string, unknown>,
  ): Promise<InvokeServerMethodResponse> {
    return this.post(
      `/server-actions/${name}/run`,
      {
        context,
        payload,
      },
      {
        params,
      },
    );
  }

  public async getAppConfig(): Promise<{
    version: string;
    clientEvents: string;
  }> {
    return this.get('/config');
  }

  public async getClientEventsPage(): Promise<{ html: string }> {
    return this.get('/client-events');
  }
}

const LdsApiClient = new LocalDevServerApiClient();

export { LdsApiClient };
